import { Component, ViewEncapsulation } from '@angular/core';
import '@fitnesspassport/wc-new-member-conversion';

@Component({
  selector: 'nmc-member-conversion',
  templateUrl: './new-member-conversion.component.html',
  styleUrls: ['./new-member-conversion.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class NewMemberConversionComponent {
  flowType: string = 'landing';

  public setReturningFlowType() {
    this.flowType = 'returning';
  }
}
